import { numConvert, sum } from '@/method';
import moment from "moment";
import _ from "lodash";
import request from "@/method/request";
import { data2_1 } from './data';
import { message } from "antd";

export default function compute({ data, date }) {
    const year = moment(date).format('YYYY');
    // 计算一
    let rowNum = [0, 1, 5, 6, 7, 9, 11, 13, 15, 17, 21, 24, 25, 26, 28, 29, 30, 31];
    if (year >= 2022) rowNum = [...rowNum, 33, 36, 37, 38, 43, 41, 42, 46, 47, 48, 49, 52, 56, 57, 58, 59, 62, 63, 64, 65, 69, 71, 72];
    const rowNameData = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const rowNextData = ['nextJan', 'nextFeb', 'nextMar'];
    for (let index = 0; index < rowNum.length; index++) {
        data[rowNum[index]].whole = rowNameData.reduce((a, b) => {
            a += numConvert(data[rowNum[index]][b]);
            return a
        }, 0).toFixed(2);
        data[rowNum[index]].nextQ1 = rowNextData.reduce((a, b) => {
            a += numConvert(data[rowNum[index]][b]);
            return a
        }, 0).toFixed(2);
        // (data[rowNum[index]].whole).toFixed(2);
        // (data[rowNum[index]].nextQ1).toFixed(2);
    }
    // 计算二
    const nameData = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'nextJan', 'nextFeb', 'nextMar', 'whole', 'nextQ1'];

    for (let index = 0; index < nameData.length; index++) {
        // 提前计算毛利润 GOP
        // 总收入
        data[8][nameData[index]] = (numConvert(data[7][nameData[index]]) + numConvert(data[6][nameData[index]]) + numConvert(data[5][nameData[index]])).toFixed(2);
        //  GOP
        data[22][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[21][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(3);
        //  盈亏平衡点/总费用
        data[23][nameData[index]] = (numConvert(data[8][nameData[index]]) - numConvert(data[21][nameData[index]])).toFixed(2);

        // 客房率
        data[2][nameData[index]] = (numConvert(data[0][nameData[index]]) == 0 ? 0 : numConvert(data[1][nameData[index]]) / numConvert(data[0][nameData[index]])).toFixed(3);
        // 平均房价
        data[3][nameData[index]] = (numConvert(data[1][nameData[index]]) == 0 ? 0 : numConvert(data[5][nameData[index]]) / numConvert(data[1][nameData[index]])).toFixed(2);
        // 平均收入
        data[4][nameData[index]] = (numConvert(data[0][nameData[index]]) == 0 ? 0 : numConvert(data[5][nameData[index]]) / numConvert(data[0][nameData[index]])).toFixed(2);

        // 客房部门利润百分比
        data[10][nameData[index]] = (numConvert(data[5][nameData[index]]) == 0 ? 0 : numConvert(data[9][nameData[index]]) / numConvert(data[5][nameData[index]])).toFixed(3);
        // 餐饮部门利润百分比
        data[12][nameData[index]] = (numConvert(data[6][nameData[index]]) == 0 ? 0 : numConvert(data[11][nameData[index]]) / numConvert(data[6][nameData[index]])).toFixed(3);
        // 食品成本百分比
        data[14][nameData[index]] = (numConvert(data[6][nameData[index]]) == 0 ? 0 : numConvert(data[13][nameData[index]]) / numConvert(data[6][nameData[index]])).toFixed(3);
        // 人力资源成本
        data[16][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[15][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(3);
        // 能源成本
        data[18][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[17][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(3);
        // 其他费用成本
        data[19][nameData[index]] = (numConvert(data[23][nameData[index]]) - numConvert(data[17][nameData[index]]) - numConvert(data[15][nameData[index]]) - numConvert(data[13][nameData[index]])).toFixed(2);
        // 其他费用成本率
        data[20][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[19][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(3);
        // 总收费
        data[27][nameData[index]] = (numConvert(data[26][nameData[index]]) + numConvert(data[25][nameData[index]]) + numConvert(data[24][nameData[index]])).toFixed(2);
    }
    // 2022年新增行数
    if (data.length > 70 && year >= 2022) {
        nameData.forEach(name => {
            data[34][name] = (numConvert(data[33][name]) + numConvert(data[13][name])).toFixed(2);
            data[39][name] = sum([
                data[38][name],
                data[37][name],
                data[36][name],
            ]);
            data[44][name] = sum([
                data[43][name],
                data[42][name],
                data[41][name],
            ]);
            data[49][name] = sum([
                data[48][name],
                data[47][name],
                data[46][name],
            ]);
            data[50][name] = sum([
                data[49][name],
                data[44][name],
                data[39][name],
                data[34][name],
            ]);
            data[53][name] = sum([
                data[52][name],
                data[9][name],
                data[11][name],
            ]);
            data[60][name] = sum([
                data[59][name],
                data[58][name],
                data[57][name],
                data[56][name],
            ]);
            data[66][name] = sum([
                data[17][name],
                data[65][name],
                data[64][name],
                data[63][name],
                data[62][name],
            ]);
            data[67][name] = sum([
                data[66][name],
                data[60][name],
            ]);
            data[68][name] = (numConvert(data[53][name]) - numConvert(data[67][name])).toFixed(2);
            data[73][name] = sum([
                data[72][name],
                data[71][name],
                data[26][name],
            ]);
            data[74][name] = (numConvert(data[21][name]) - numConvert(data[73][name])).toFixed(2);
        })
    }
    return data
}

export const saveAllData = async (date) => {
    // 获取所有酒店 
    const { data: { hotels } } = await request('/getHotels');
    for (let i = 0; i < hotels.length; i++) {
        const item = hotels[i];
        //  获取当前酒店数据  
        const year = moment(date).format('YYYY');
        const dataDefault = year >= 2022 ? _.cloneDeep(data2_1) : _.cloneDeep(data2_1).slice(0, 33);
        let data = dataDefault.filter((x, i) => i != 0);
        let dataSelect = dataDefault.filter((x, i) => i == 0);
        const { data: x } = await request(`/_2_1_all?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}&comid=${item.id}`);
        if (x.data && x.data.length > 0) {
            data = x.data2_1.filter((x, i) => i != 0);
            dataSelect = x.data2_1.filter((x, i) => i == 0);
        } else if (x.dataLastMonth && x.dataLastMonth.length > 0) {
            // 获取当前月份之前所有的月份的实际数据
            let len = Number(moment(date).format('M') || "0") - 1;
            let name = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

            let newData = x.dataLastMonth.filter((x, index) => index != 0);
            // 自动填充淡旺季
            dataSelect = x.dataLastMonth.filter((x, i) => i == 0).map(x => { delete x.id; return x });
            if (newData && newData.length > 0) {
                for (let i = 0; i < name.length; i++) {
                    if (i != len) {
                        data = data.map((z, index) => ({ ...z, [name[i]]: z[name[i]] != 0 ? z[name[i]] : _.get(newData, `${index}.${name[i]}`, 0) }));
                    }
                }
            }
        }
        data = compute({ data, date });
        let month = moment(date).format("M");
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify([...dataSelect, ...data].map(x => ({ ...x, year, month, comid: item.id }))));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        };
        await request('/add_2_1', headres);
    }
    message.success('保存成功！');
}


// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-1/compute.js